import React from "react";
import { useCurrentShipmentType } from "../hooks/useCurrentShipmentType.js";

export const ImportShipment=({children})=>{
    const {isImportShipment}=useCurrentShipmentType()
    return isImportShipment ? children :null
}